/* RR V1.1: animation & navigation enhancement. No heavy dependencies. */
(function(){
  'use strict';
  function init(root){
    root=root||document;
    root.querySelectorAll('[data-rr-v11-navigation]').forEach(function(nav){
      if(nav.dataset.rrReady)return;
      nav.dataset.rrReady='1';
      var groups=Array.prototype.slice.call(nav.querySelectorAll('[data-rr-nav-item]'));
      // The desktop dropdown must remain open anywhere over the whole header
      // (including the mega panel), not only while its top-level link is hovered.
      var header=nav.closest('.rr-header') || nav.closest('header') || nav;
      var leaveTimer=null;
      var desktop=window.matchMedia('(min-width:1100px) and (hover:hover) and (pointer:fine)');
      function cancelClose(){
        if(leaveTimer!==null){window.clearTimeout(leaveTimer);leaveTimer=null;}
      }
      function closeAll(except){
        cancelClose();
        groups.forEach(function(g){
          if(g===except)return;
          g.classList.remove('rr-v11-open');
          var b=g.querySelector('[data-rr-nav-toggle]');
          if(b)b.setAttribute('aria-expanded','false');
        });
      }
      function openGroup(group,trigger){
        cancelClose();
        closeAll(group);
        group.classList.add('rr-v11-open');
        trigger.setAttribute('aria-expanded','true');
      }
      function delayedClose(){
        cancelClose();
        leaveTimer=window.setTimeout(function(){
          leaveTimer=null;
          // Moving between the header and a transitioning panel can briefly
          // produce a pointer-leave; do not close if the cursor is back inside.
          if(!header.matches(':hover'))closeAll();
        },180);
      }
      header.addEventListener('mouseenter',cancelClose);
      header.addEventListener('mouseleave',function(){if(desktop.matches)delayedClose();});
      header.addEventListener('focusout',function(e){
        if(!header.contains(e.relatedTarget) && !header.matches(':hover'))closeAll();
      });
      groups.forEach(function(group){
        var trigger=group.querySelector('[data-rr-nav-toggle]');
        if(!trigger)return;
        group.addEventListener('mouseenter',function(){
          if(desktop.matches)openGroup(group,trigger);
        });
        group.addEventListener('focusin',function(){openGroup(group,trigger);});
        // Do NOT close on the individual item leaving: the visitor may be
        // crossing the header or moving into its absolutely positioned panel.
        if(trigger.tagName==='BUTTON')trigger.addEventListener('click',function(){
          var isOpen=group.classList.contains('rr-v11-open');
          closeAll();
          if(!isOpen)openGroup(group,trigger);
        });
        group.addEventListener('keydown',function(e){
          if(e.key==='Escape'){
            closeAll();
            trigger.focus();
          }
        });
      });
      document.addEventListener('click',function(e){
        if(!header.contains(e.target))closeAll();
      });
    });
    root.querySelectorAll('[data-rr-v11-mobile] details').forEach(function(item){if(item.dataset.rrReady)return;item.dataset.rrReady='1';item.addEventListener('toggle',function(){if(!item.open)return;var siblings=item.parentNode.querySelectorAll('details');siblings.forEach(function(s){if(s!==item)s.open=false;});});});
  }
  function setupMotion(){
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    if(!('IntersectionObserver' in window))return;
    var targets=document.querySelectorAll('.rr-campaign__intro h2,.rr-campaign-products .rr-plp-card,.rr-campaign-spotlight__title,.rr-campaign-spotlight__feature,.rr-campaign-spotlight__grid .rr-plp-card,.rr-campaign-story__title,.rr-campaign-story__gallery');
    if(!targets.length)return;
    var obs=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('rr-v11-visible');obs.unobserve(entry.target);}});},{threshold:.05,rootMargin:'0px 0px 60px 0px'});
    targets.forEach(function(el){el.classList.add('rr-v11-reveal');obs.observe(el);});
    document.documentElement.classList.add('rr-v11-motion-ready');
  }
  function main(){
    init(document);
    if(window.Shopify&&window.Shopify.designMode)return;
    setupMotion();
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    if(window.matchMedia&&window.matchMedia('(max-width:749px)').matches)return;
    var hero=document.querySelector('.rr-campaign-hero');
    if(hero){hero.classList.add('rr-v11-hero-animate');requestAnimationFrame(function(){requestAnimationFrame(function(){hero.classList.add('rr-v11-hero-show');});});}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',main,{once:true});else main();
  document.addEventListener('shopify:section:load',function(ev){init(ev.target);ev.target.querySelectorAll('.rr-v11-reveal').forEach(function(el){el.classList.add('rr-v11-visible');});});
  document.addEventListener('shopify:section:select',function(ev){ev.target.querySelectorAll('.rr-v11-reveal').forEach(function(el){el.classList.add('rr-v11-visible');});});
})();
